import React, { Component } from 'react'
import { Button, Icon, Row, Switch } from 'antd'
import { siteContent, embedded } from '@services/api'

export default class extends Component {
    state = { lngs: [], multiLng: true, content: { key: '', links: {} } }
    componentDidMount() {
        siteContent
            .getSiteLngs()
            .then(res => {
                let lngs = res.data.map(slot => slot.lng)
                this.setState({
                    lngs,
                    content: {
                        ...this.state.content,
                        links: lngs.map(lng => {
                            return { lng, link: '' }
                        })
                    }
                })
            })
            .catch(err => console.log({ err }))
    }

    componentDidUpdate(prevP, prevS) {
        let { multiLng, lngs, content } = this.state
        if (prevS.multiLng != this.state.multiLng) {
            this.setState({
                content: {
                    key: content.key,
                    [multiLng ? 'links' : 'link']: multiLng
                        ? lngs.map(lng => {
                              return { lng, link: '' }
                          })
                        : ''
                }
            })
        }
    }
    render() {
        const { lngs, content } = this.state
        return (
            <>
                <Row gutter={28} style={{ marginBottom: 10 }}>
                    <span>
                        מפתח:
                        <input
                            value={content.key}
                            onChange={e => this.setState({ content: { ...content, key: e.target.value } })}
                        />
                    </span>
                    <span style={{ marginRight: 10 }}>
                        משתנה בהתאם לשפה?
                        <Switch defaultChecked onChange={val => this.setState({ multiLng: val })} />
                    </span>
                </Row>

                {content.links ? (
                    lngs.map((lng, idx) => (
                        <Row key={idx} gutter={28}>
                            <span>
                                {lng} -
                                <input
                                    value={content.links[lng]}
                                    onChange={e =>
                                        this.setState({
                                            content: {
                                                ...content,
                                                links: content.links.map(item => {
                                                    return item.lng == lng ? { ...item, link: e.target.value } : item
                                                })
                                            }
                                        })
                                    }
                                />
                            </span>
                        </Row>
                    ))
                ) : (
                    <Row gutter={28}>
                        <span>
                            <input
                                value={content.link}
                                onChange={e =>
                                    this.setState({
                                        content: {
                                            ...content,
                                            link: e.target.value
                                        }
                                    })
                                }
                            />
                        </span>
                    </Row>
                )}
                <Button
                    style={{ marginTop: 10 }}
                    onClick={() => {
                        embedded.addEmbedded(content)
                    }}
                >
                    <Icon type="check" />
                </Button>
            </>
        )
    }
}
